import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/authentication.service';
import { AngularFireAuth } from '@angular/fire/auth';
import 'bootstrap/dist/js/bootstrap.bundle';
import { ApiService } from '../../shared/api.service';
import { CacheService } from '../../shared/cache.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import Timestamp = firebase.firestore.Timestamp;
import * as firebase from 'firebase';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import * as moment from 'moment';
import {Router} from "@angular/router";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  uidControl = new FormControl();
  userList: any;
  filteredOptions: Observable<any>;

  isSuperUser = false;
  userdata: any;
  isOrgAdmin = false;
  userRole;
  path;
  displayName: string;
  idToken: string;
  userDisplayData;
  displayHeaderNav = false;
  optionsSelect: any;
  testTypeOptions: string[];
  private userOrgData: any;
  selectedTestType: string;
  otherTestType: string;

  // New Test object to be filled with modal form and sent to API
  newTest: {
    // date: firebase.firestore.Timestamp;
    uid: string;
    date: any;
    note: string;
    location: any;
    calculationResult: {
      textDescription: string;
      testType: string;
    };
  };
  displayHeader = false;


  constructor(public authenticationService: AuthenticationService,
              private apiService: ApiService,
              private angularFireAuth: AngularFireAuth,
              private cacheService: CacheService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        // Display header nav links if logged in
        this.displayHeaderNav = true;

        // Display entire header if not on API reference page
        this.displayHeader = !window.location.pathname.includes('/api/reference');


        // Load newTest props
        this.newTest = {
          location: undefined,
          uid: user.uid,
          calculationResult: {
            textDescription: '',
            testType: ''
          },
          note: '',
          date: undefined
        };
        this.userdata = this.authenticationService.userData;
        this.isOrgAdmin = this.authenticationService.isOrgAdmin;
        this.userRole = this.authenticationService.userRole;
        this.isSuperUser = this.userRole === 'superuser';
        const token = await user.getIdTokenResult();
        this.idToken = token.token;
        this.userDisplayData = await this.apiService.getUserData(user.uid, this.idToken);

        // tslint:disable-next-line:max-line-length
        this.userOrgData = await this.authenticationService.getUserOrgData(this.userDisplayData.data.orgData?.orgId || this.userDisplayData.data.orgId);

        // Get available test types based on user/org enabled tests

        this.testTypeOptions = this.userDisplayData.data.customTestsEnabled ?
          // User custom types
          this.userDisplayData.data.enabledTests.filter(test => !this.userDisplayData.data.hiddenTests.includes(test)) :
          // Org custom types
          this.userOrgData.enabledTests.filter(test => !this.userOrgData.hiddenTests.includes(test));

        // Add "other" to test types
        this.testTypeOptions.push('other');

        // tslint:disable-next-line:max-line-length
        this.displayName = this.userDisplayData?.data.displayName || this.userDisplayData?.data.email || this.userdata.displayName || this.userdata.email;


        // user list filtering for superusers and org admins
        if (this.isSuperUser || this.isOrgAdmin) {
          // fetch user list from cache service or fetch from api
          this.userList = this.cacheService.userFilterList || (
            this.isSuperUser ?
              // get all users if superuser
              await this.apiService.getAllUsers(this.idToken) :
              // get org users if org admin
              await this.apiService.getOrgUsers(this.idToken, this.userOrgData.id)
          );
          this.filteredOptions = this.uidControl.valueChanges
            .pipe(
              startWith(''),
              map(value => this._filter(value))
            );
        }
      }
    });
    this.path = window.location.pathname;
  }


  displayFn(user: any): string {
    return user?.displayName || user?.email || user?.userRecord?.displayName || user?.userRecord?.email || '';
  }


  private _filter(value: string): any[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.userList.filter(user => {
        return (
          // Accounting for different types of user data, some have userRecord (from fire auth)
          user.displayName?.toLowerCase().includes(filterValue) ||
          user.email?.toLowerCase().includes(filterValue) ||
          user.userRecord?.displayName?.toLowerCase().includes(filterValue) ||
          user.userRecord?.email?.toLowerCase().includes(filterValue)
        );
      });
    }
  }

  updateActive(pathname?: string) {
    this.path = pathname ? pathname : window.location.pathname;
    const elements = document.getElementsByClassName('active');
    if (elements[0]) {
      elements[0].classList.remove('active');
    }
    let element;
    switch (this.path) {
      case '/profile':
        element = document.getElementById('nav-profile');
        element.classList.add('active');
        break;
      case '/tests':
        element = document.getElementById('nav-dashboard');
        element.classList.add('active');
        break;
      case '/locations':
        element = document.getElementById('nav-locations');
        element.classList.add('active');
        break;
      case '/user-management':
        element = document.getElementById('nav-user-management');
        element.classList.add('active');
        break;
      case '/map-view':
        element = document.getElementById('nav-map-view');
        element.classList.add('active');
        break;
      case '/organizations':
        element = document.getElementById('nav-org-management');
        element.classList.add('active');
        break;
      default:
        break;
    }
  }

  signOut() {
    // if (this.cacheService.testListCached || this.cacheService.locationListCached) {
      this.cacheService.clearCache();
    // }
      this.displayHeaderNav = false;
      this.authenticationService.SignOut();
  }

  profile() {
    this.router.navigate(['/profile']);
  }

  async addTest() {
    // Send new test data to API to create new test
    try {
      if (this.otherTestType) {
        this.newTest.calculationResult.testType = `Other (${this.otherTestType})`;
      }
      const response = await this.apiService.createTest(this.newTest, this.idToken);
    } catch (e) {
    }
  }

  updateTestType() {
    this.newTest.calculationResult.testType = this.selectedTestType;
  }

  updateTestLocation(location: any) {
    this.newTest.location = location;
  }

  updateTestWaterSource(waterSource: any) {
    this.newTest.location.waterSource = waterSource.name;
  }

  setTestUid($event: MatAutocompleteSelectedEvent) {
    this.newTest.uid = $event.option.value.uid || $event.option.value.userRecord?.uid;
  }
}
